/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import * as React from 'react';
import {Field} from 'redux-form';
import {TextField} from 'src/js/components/form/TextField';
import {replaceWithNl} from 'src/js/common/utils/HtmlUtils';

export interface Props {
  header?: string;
}

export class CompanyAdd extends React.Component<Props, any> {
  render() {
    const {header = 'Enter the business to be invoiced and paying for this transaction.'} = this.props;
    return (
      <div id="addstudent-block">
        <div className="message">
          <p style={{whiteSpace: 'pre-line'}}>{replaceWithNl(header)}</p>
        </div>
        <fieldset className="field-wrapper company-add-wrapper">
          <Field
             component={TextField}
             autocomplete="family-name"
             name="lastName"
             label="Company name"
             type="text"
             required
          />
          <Field
             component={TextField}
             autocomplete="email"
             name="email"
             label="Email"
             type="email"
             required
          />
        </fieldset>
        <p className="note">
          <strong className="alert">Note</strong>: If you have been here before, please try to use the same email
          address.
        </p>
      </div>);
  }
}
